import { render, staticRenderFns } from "./check-item.vue?vue&type=template&id=8966765a&scoped=true&"
import script from "./check-item.vue?vue&type=script&lang=js&"
export * from "./check-item.vue?vue&type=script&lang=js&"
import style0 from "./check-item.vue?vue&type=style&index=0&id=8966765a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8966765a",
  null
  
)

export default component.exports